import { render, staticRenderFns } from "./SellingInfoFlip.vue?vue&type=template&id=3db5990a&scoped=true&"
import script from "./SellingInfoFlip.vue?vue&type=script&lang=js&"
export * from "./SellingInfoFlip.vue?vue&type=script&lang=js&"
import style0 from "./SellingInfoFlip.vue?vue&type=style&index=0&id=3db5990a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5990a",
  null
  
)

export default component.exports